import { ComponentProps } from 'react';

import { MessageCircleIcon } from '@braskai/icons';

import { Stack } from '@mui/material';

import { useHubSpotChatStore } from '../hooks/useHubSpotChatStore';

export const ChatIcon = (props: ComponentProps<typeof MessageCircleIcon>) => {
  const hasUnreadConversation = useHubSpotChatStore((state) => state.unreadCount > 0);

  return (
    <Stack
      sx={(theme) => ({
        ':before': {
          backgroundColor: theme.palette.primary[500],
          borderRadius: '50%',
          content: '""',
          height: 8,
          opacity: hasUnreadConversation ? 1 : 0,
          position: 'absolute',
          right: -2,
          top: -2,
          transition: 'opacity 0.3s ease-in-out',
          width: 8,
        },
        position: 'relative',
      })}
      alignItems="center"
      justifyContent="center"
    >
      <MessageCircleIcon {...props} />
    </Stack>
  );
};
